export default "__VITE_ASSET___I7ZwHww__"